import { get, post } from 'pc-sales/utils/http';

export class TeamApi {
    // 获取销售团队列表
    get = async (data: { page?: number; pagesize?: number }) => await get('/v2/team/manage', data);

    // 获取销售团队列表(包含成员信息)
    getList = (data: {
        page?: number;
        pagesize?: number;
        team_member_size?: number; // 成员数量
    }) => get('/v2/team/manage/list', data);

    // 获取团队下所有销售
    allMember = () => get('/v2/team/manage/allMember');

    // 更新销售团队信息
    update = async (data: { id: string; team_name?: string; team_logo?: string; team_color?: string }) =>
        await post('/v2/team/manage/update', data);

    // 创建销售团队
    create = async (data: { team_name: string; team_logo?: string; team_color?: string }) =>
        await post('/v2/team/manage/create', data);

    // 删除销售团队
    delete = async (data: { id: string }) => await post('/v2/team/manage/destroy', data);

    // 校验团队
    validate = async (data: { team_name: string }) => await post('/v2/team/manage/validate', data);

    // 校验团队
    member = (data: {
        page?: string;
        pagesize?: string;
        team_id: string;
        ustatus?: '0' | '2';
        uroleid?: string;
        user_id?: string;
        uphone?: string;
        uemail?: string;
        sale?: string;
        from?: string;
        to?: string;
    }) => get('/v2/team/manage/member', data);

    // 获取团队客户信息
    info = async (data: { id: string }) => await get('/v2/team/client/show', data);

    // 获取团队客户列表
    clientList = async (
        data: {
            page?: number;
            pagesize?: number;
            from?: string;
            to?: string;
            node?: string;
            search_phone?: string;
            search_email?: string;
            sales_phone?: string;
            sales_email?: string;
            isHierarchy?: string;
            audit_status?: string;
        },
        options?: { signal?: AbortSignal },
    ) => await get('/v2/team/client', data, { signal: options?.signal });

    // 获取销售团队客户交易账号列表
    account = async (
        data: {
            server_id: string;
            platform: 'MT4' | 'MT5';
            page: number | string;
            pagesize: number | string;
            from?: string;
            to?: string;
            login?: number | string;
            name?: string;
            sales_uuid?: string;
            esnl_acc_type_id?: number;
            sub_acc_type_id?: string;
        },
        options?: { signal?: AbortSignal },
    ) => await get('/v2/team/client/account', data, { signal: options?.signal });
}

export default new TeamApi();
